import type { SelectedVisit, Visit } from './visitAttachmentsTypes';
import { VisitTag } from './VisitTag';

interface VisitTagsListProps {
  selectedVisits: SelectedVisit[];
  visits: Visit[];
  onRemoveVisit: (visit: Visit) => void;
}

export const VisitTagsList = ({
  selectedVisits,
  visits,
  onRemoveVisit,
}: VisitTagsListProps) => {
  if (selectedVisits.length === 0) {
    return null;
  }

  return (
    <div className="vai-flex vai-flex-wrap vai-gap-2 vai-mt-2">
      {selectedVisits.map((selectedVisit) => (
        <VisitTag
          key={selectedVisit.id}
          visit={selectedVisit}
          originalVisit={visits.find((v) => v.id === selectedVisit.id)}
          onRemove={onRemoveVisit}
        />
      ))}
    </div>
  );
};
